import { DescriptionPage_UpsellType as UpsellType } from '__generated__/graphql-types';

import type { DegreeFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

import _t from 'i18n!nls/xdp';

const getUpsellCaption = (degrees: Array<DegreeFragment>): string => {
  // Use the first upsell when there are multiple
  const upsellType = degrees[0]?.upsellType;

  if (upsellType === UpsellType.PartOf) {
    return _t('Progress towards a degree');
  } else if (upsellType === UpsellType.OffersCredit) {
    return _t('Earn degree credit');
  } else {
    return _t('Prepare for a degree');
  }
};

export default getUpsellCaption;
